import { ArrowUpRight } from "lucide-react";
import { useWaitlistModal } from "@/components/waitlist/WaitlistContext";

interface CtaBlockRendererProps {
  text: string;
}

export default function CtaBlockRenderer({ text }: CtaBlockRendererProps) {
  const { openModal } = useWaitlistModal();

  return (
    <div className="not-prose cta-block-surface rounded-3xl py-12 md:py-16 px-10 md:px-16 text-center cta-block-breakout">
      <div className="max-w-none text-2xl md:text-3xl lg:text-4xl font-bold mb-10 leading-tight">
        {text}
      </div>

      <button
        onClick={() => openModal('inline_article_cta')}
        className="cta-block-button group inline-flex items-center gap-2 rounded-full border px-6 py-3 text-sm font-medium transition-all duration-300"
      >
        Join waitlist
        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </button>
    </div>
  );
}
